import Routine_consultation from 'assets/consulta_rotina.svg';
import Emergency from 'assets/emergencia.svg';
import Urgency from 'assets/urgencia.svg';

import { IPet } from './Pet';
import { ITutor } from './Tutor';

export interface ITreatment {
  _id: string;
  id: string;
  pet: IPet;
  vet: string;
  tutor: string;
  inCall: boolean;
  createdAt: string;
  updatedAt: string;
  callUrl: string;
  baseUrl: string;
  roomId: string;
  __v: number;
}

export interface ITreatmentOnGoing {
  _id: string;
  annotations: string;
  id: string;
  pet: IPet;
  vet: string;
  tutor: ITutor;
  symptoms: Symptoms[];
  generalClassification: Symptoms['classification'];
  inCall: boolean;
  createdAt: string;
  updatedAt: string;
  callUrl: string;
  baseUrl: string;
  documents: any[]
  roomId: string;
  __v: number;
}

export interface ILocation {
  type: string;
  coordinates: number[];
  _id: string;
}

export interface RiskClassification {
  name: string;
  image: string;
  color: string;
  generalClassification?: string;
}

export interface Symptoms {
  name: string;
  classification: ITreatmentClassification;
  number: number;
  _id: string;
}

export const ThemeClassification = {
  EMERGENCY: { color: '#FF0000', icon: Emergency, title: 'Emergência' },
  URGENCY: { color: '#F9BB2D', icon: Urgency, title: 'Urgência' },
  ROUTINE_CONSULTATION: {
    color: '#4688F1',
    icon: Routine_consultation,
    title: 'Consulta de rotina',
  },
};

export type ITreatmentClassification = keyof typeof ThemeClassification;

export enum SocketTreatmentEvents {
  /* General events */
  'CONNECT' = 'connect',

  /* Tutor emissor events */
  // Treatment queue has updated and notify all vets
  'TUTOR_TREATMENT_UPDATE_VET_QUEUE' = 'tutor-treatment-update-vet-queue',
  // Tutor has rejected incoming call
  'TUTOR_TREATMENT_REJECT_CALL' = 'tutor-treatment-reject-call',
  // Tutor has accepted incoming call
  'TUTOR_TREATMENT_ACCEPT_CALL' = 'tutor-treatment-accept-call',

  /* Vet emissor */
  // Vet is joining to treatment room
  'TUTOR_TREATMENT_VET_JOINING_ROOM' = 'tutor-treatment-vet-joining-room',
  'TUTOR_TREATMENT_JOIN_WAITING' = 'tutor-treatment-join-waiting',
  // Vet started a call and request tutor to join
  'TUTOR_TREATMENT_WAITING_INCOMING_CALL' = 'tutor-treatment-waiting-incoming-call',

  /* Vet emissor events */
  // Contact tutor informing that vet is has finished the treament room
  'TUTOR_TREATMENT_FINISH_CALL' = 'tutor-treatment-finish-call',
  // Send update position to all tutors that are waiting for treatments
  'TUTOR_TREATMENT_WAITING_UPDATE_POSITION' = 'tutor-treatment-waiting-update-position',
}

